import { call, put, takeLatest, fork, all, delay } from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as Func from "../helpers/functions";
import i18n from '../constants/initLng';
import * as OrderActions from '../actions/orderAction';
import * as OrderService from '../services/orderService';
import * as FlightService from '../services/flightService';
import * as VoucherService from '../services/voucherService';
import * as HotelService from '../services/hotelService';
import * as HomestayService from '../services/homestayService';
import * as TourService from '../services/tourService';
import { parseOrderVoucherItemDetailListRequestParams, parseListRequestParams, parseListRequestParamsCameo } from '../utils/commonUtils';
import { notification, message } from 'antd';
import { faIgloo } from '@fortawesome/free-solid-svg-icons';
import { omit, get } from 'lodash';
import Order from '../models/Order';
import { SAGA_DELAY_TIMEOUT } from "../constants/Define";
import moment from 'moment';

function* pushOrderFixCharge() {
    yield takeLatest(Types.ORDER_PUSH_FIXED_CHARGE_ACTION, Func.sagaWrapper(function* (action) {
        const orderId = action.orderId || 0;
        const params = { orderId }
        const result = yield call(OrderService.pushFixedCharge, params);
        yield put(OrderActions.pushFixChargeSuccess(result));
        Func.sagaSuccessMessage(action, i18n.t('notification.pushFixedChargeSuccess'));
        yield put({ type: Types.ORDER_RESEND_EMAIL_SUCCESS, result });
    }, errorHandleOrder(Types.ORDER_PUSH_FIXED_CHARGE_FAIL)))
}



function* getListOrder() {
    yield takeLatest(Types.ORDER_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseListRequestParams(action.filters || {});
        const result = yield call(OrderService.getOrders, params);
        yield put(OrderActions.dataOrderSuccess(result));
    }, errorHandleOrder(Types.ORDER_FAIL)))
}

function* getOrderItem() {
    yield takeLatest(Types.ORDER_ITEM_GET_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(OrderService.getOrderItems, action.id);
        yield put(OrderActions.getOrderItemSuccess(result));
    }, errorHandleOrder(Types.ORDER_FAIL)))
}

function* getItemVoucherOrder() {
    yield takeLatest(Types.ORDER_VOUCHER_GET_ITEM_ACTION, Func.sagaWrapper(function* (action) {
        const params = action.params || {};
        const result = yield call(OrderService.getOrderItems, params.id);
        result.id = params.id;
        yield put(OrderActions.getItemVoucherOrderSuccess(result));
    }, errorHandleOrder(Types.ORDER_FAIL)))
}

function* reSendOrderEmail() {
    yield takeLatest(Types.ORDER_RESEND_EMAIL_ACTION, Func.sagaWrapper(function* (action) {
        yield call(OrderService.resendEmail, action.params.id);
        orderSuccessMessage(action, i18n.t('notification.resendmailsuccess'));
        yield put({ type: Types.ORDER_RESEND_EMAIL_SUCCESS });
    }, errorHandleOrder(Types.ORDER_FAIL)))
}

function* sendOrderEmailTemplate() {
    yield takeLatest(Types.ORDER_SEND_EMAIL_TEMPLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(OrderService.sendEmailTemplate, action.order.id, action.emailTemplate.id);
        orderSuccessMessage(action, i18n.t('notification.resendmailsuccess'), action.emailTemplate.title);
        yield put({ type: Types.ORDER_SEND_EMAIL_TEMPLATE_SUCCESS });
        yield put({ type: Types.ORDER_DETAIL_ACTION, id: action.order.id });
    }, errorHandleOrder(Types.ORDER_FAIL)))
}

function* getOrderDetail() {
    yield takeLatest(Types.ORDER_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(OrderService.getOrderDetail, action.id);
        yield put(OrderActions.setOrderDetail(result));
    }, errorHandleOrder(Types.ORDER_FAIL)))
}

function* getOrderVoucherDetailItems() {
    yield takeLatest(Types.ORDER_VOUCHER_GET_DETAIL_VOUCHER_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseOrderVoucherItemDetailListRequestParams(action.params || {});
        const result = yield call(VoucherService.getOrderVoucherDetailItems, params);
        yield put(OrderActions.getDetailVoucherOrderSuccess(result));
    }, errorHandleOrder(Types.ORDER_FAIL)))
}

function* getOrderFlightDetail() {
    yield takeLatest(Types.ORDER_FLIGHT_GET_ITEM_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(FlightService.getOrderFlightItem, action.productVariantId);
        yield put(OrderActions.setOrderFlightItem(result));
    }, errorHandleOrder(Types.ORDER_FAIL)))
}

function* getOrderHotelBooking() {
    yield takeLatest(Types.ORDER_HOTEL_GET_BOOKING_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(HotelService.getHotelBooking, action.productVariantIds);
        yield put(OrderActions.setOrderHotelBooking(result));
    }, errorHandleOrder(Types.ORDER_FAIL)))
}

function* getOrderHomestayBooking() {
    yield takeLatest(Types.ORDER_HOMESTAY_GET_BOOKING_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(HomestayService.getHomestayBooking, action.productVariantIds);
        yield put(OrderActions.setOrderHomestayBooking(result));
    }, errorHandleOrder(Types.ORDER_FAIL)))
}

function* getOrderCrossSellBooking() {
    yield takeLatest(Types.ORDER_CROSSSELL_GET_BOOKING_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(HotelService.getCrossSellBooking, action.productVariantIds);
        yield put(OrderActions.setOrderCrossSellBooking(result));
    }, errorHandleOrder(Types.ORDER_FAIL)))
}

function* exportExcel() {
    yield takeLatest(Types.ORDER_EXPORT_EXCEL_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseListRequestParams(action.params || {});
        const result = yield call(OrderService.exportExcel, params);
        downloadFileExcel(result);
        orderSuccessMessage(action, `${i18n.t('notification.downloadSuccess')}`);
        yield put({ type: Types.ORDER_EXPORT_EXCEL_SUCCESS });
    }, errorHandleOrder(Types.ORDER_EXPORT_EXCEL_FAIL)))
}

function* exportSkuExcel() {
    yield takeLatest(Types.ORDER_EXPORT_SKU_EXCEL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(OrderService.exportSkuExcel, action.params);
        downloadFileExcel(result);
        orderSuccessMessage(action, `${i18n.t('notification.downloadSuccess')}`);
        yield put({ type: Types.ORDER_EXPORT_EXCEL_SUCCESS });
    }, errorHandleOrder(Types.ORDER_EXPORT_EXCEL_FAIL)))
}

function* exportSkuSaleDetailExcel() {
    yield takeLatest(Types.ORDER_EXPORT_SKU_SALE_DETAIL_EXCEL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(OrderService.exportSkuSaleDetailExcel, action.params);
        downloadFileExcel(result);
        orderSuccessMessage(action, `${i18n.t('notification.downloadSuccess')}`);
        yield put({ type: Types.ORDER_EXPORT_EXCEL_SUCCESS });
    }, errorHandleOrder(Types.ORDER_EXPORT_EXCEL_FAIL)))
}

function* exportHotelSaleDetailExcel() {
    yield takeLatest(Types.ORDER_EXPORT_HOTEL_SALE_DETAIL_EXCEL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(OrderService.exportHotelSaleDetailExcel, action.params);
        downloadFileExcel(result);
        orderSuccessMessage(action, `${i18n.t('notification.downloadSuccess')}`);
        yield put({ type: Types.ORDER_EXPORT_EXCEL_SUCCESS });
    }, errorHandleOrder(Types.ORDER_EXPORT_EXCEL_FAIL)))
}

function* exportAccessTrade() {
    yield takeLatest(Types.ORDER_EXPORT_ACCESS_TRADE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(OrderService.exportAccessTrade, action.params);
        downloadFileExcel(result);
        orderSuccessMessage(action, `${i18n.t('notification.downloadSuccess')}`);
        yield put({ type: Types.ORDER_EXPORT_ACCESS_TRADE_SUCCESS });
    }, errorHandleOrder(Types.ORDER_FAIL)))
}

function* exportSaleOrder() {
    yield takeLatest(Types.ORDER_EXPORT_SALE_ORDER_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(OrderService.exportSaleOrder, action.saleOrder);
        orderSuccessMessage(action, `${i18n.t('item.order.saleOrderSuccess')}`, `${action.saleOrder.quantity} ${i18n.t('item.voucher.title').toLowerCase()}`);
        if (action.saleOrder.exportFile) {
            yield put({ type: Types.ORDER_EXPORT_VOUCHER_ACTION, id: result.data });
        }
        yield put({ type: Types.ORDER_EXPORT_SALE_ORDER_SUCCESS });
        yield put({ type: Types.ORDER_LIST_ACTION, filters: action.refreshParams || {} });
    }, errorHandleOrder(Types.ORDER_FAIL)))
}

function* exportTourSaleOrder() {
    yield takeLatest(Types.ORDER_EXPORT_TOUR_SALE_ORDER_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(OrderService.exportTourSaleOrder, action.tourSaleOrder);
        orderSuccessMessage(action, `${i18n.t('item.order.saleOrderSuccess')}`, ` ${i18n.t('item.tour.title').toLowerCase()}`);
        if (action.tourSaleOrder.exportFile) {
            yield put({ type: Types.ORDER_EXPORT_VOUCHER_ACTION, id: result.data });
        }
        yield put({ type: Types.ORDER_EXPORT_SALE_ORDER_SUCCESS });
        yield put({ type: Types.ORDER_LIST_ACTION, filters: action.refreshParams || {} });
    }, errorHandleOrder(Types.ORDER_FAIL)))
}

function* exportVoucher() {
    yield takeLatest(Types.ORDER_EXPORT_VOUCHER_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(OrderService.exportVoucher, action.id);
        downloadFileExcel(result);
        orderSuccessMessage(action, `${i18n.t('item.order.exportVoucherSuccess')}`);
    }, errorHandleOrder(Types.ORDER_FAIL)))
}

function* updateOrder() {
    yield takeLatest(Types.ORDER_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(OrderService.updateOrder, action.order);
        orderSuccessMessage(action, `${i18n.t('notification.updateSuccess')}`);
        // call update order status
        if (action.order.isUpdateOrderStatus) {
            yield call(OrderService.updateOrderStatus, action.order);
        }
        yield put({ type: Types.ORDER_UPDATE_SUCCESS });
        yield put({ type: Types.ORDER_DETAIL_ACTION, id: action.order.id });
    }, errorHandleOrder(Types.ORDER_FAIL)))
}

function* updateOrderAccountant() {
    yield takeLatest(Types.ORDER_UPDATE_ACCOUNTANT_ACTION, Func.sagaWrapper(function* (action) {
        yield call(OrderService.updateOrderAccountant, action.order);
        orderSuccessMessage(action, `${i18n.t('notification.updateSuccess')}`);

        yield put({ type: Types.ORDER_UPDATE_ACCOUNTANT_SUCCESS });
        yield put({ type: Types.ORDER_DETAIL_ACTION, id: action.order.id });
    }, errorHandleOrder(Types.ORDER_FAIL)))
}

function* updateFlight() {
    yield takeLatest(Types.ORDER_FLIGHT_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(OrderService.updateFlight, action.flight);
        orderSuccessMessage(action, `${i18n.t('notification.updateSuccess')}`);
        yield put({ type: Types.ORDER_FLIGHT_UPDATE_SUCCESS });
        yield put({ type: Types.ORDER_FLIGHT_GET_ITEM_ACTION, productVariantId: action.flight.id });
    }, errorHandleOrder(Types.ORDER_FAIL)))
}

function* updateOrderInvoice() {
    yield takeLatest(Types.ORDER_UPDATE_INVOICE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(OrderService.updateOrderInvoice, action.orderInvoice);
        orderSuccessMessage(action, `${i18n.t('notification.updateSuccess')}`);
        yield put({ type: Types.ORDER_UPDATE_INVOICE_SUCCESS });
        yield put({ type: Types.ORDER_DETAIL_ACTION, id: action.orderInvoice.orderId });
    }, errorHandleOrder(Types.ORDER_FAIL)))
}

function downloadFileExcel(result) {
    const fileName = result.headers['x-suggestion-filename'];
    const fileType = result.headers['content-type'];
    Func.downloadFile(result.data, fileName, { type: fileType });
}


/* SURCHARGE SAGAS */

function* getOrderSurchargeItem() {
    yield takeLatest(Types.ORDER_SURCHARGE_GET_ITEM_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseListRequestParamsCameo(action.params || {});
        const data = yield call(OrderService.getOrderSurchargeItems, action.params);
        data.listType = action.listType;
        yield put(OrderActions.setListSurcharges(data.result, { ...params, ...omit(data, 'result') }));
    }, errorHandleOrder(Types.ORDER_FAIL)))
}

function* getSurchargeDetail() {
    yield takeLatest(Types.SURCHARGE_ITEM_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(OrderService.getSurchargeDetail, action.id);
        yield put(OrderActions.setSurchargeDetail(result));
    }, errorHandleOrder(Types.ORDER_FAIL)))
}

function* getBundleOrderSurcharge() {
  yield takeLatest(Types.GET_BUNDLE_ORDER_SURCHARGE_ACTION, Func.sagaWrapper(function* (action) {
    const result = yield call(OrderService.getOrderSurchargeItems, action.params);
    yield put(OrderActions.setBundleOrderSurcharge(result));
  }, errorHandleOrder(Types.ORDER_FAIL)))
}
function* bundleOrderCreateSurcharge() {
  yield takeLatest(Types.BUNDLE_ORDER_CREATE_SURCHARGE_ACTION, Func.sagaWrapper(function* (action) {
    yield call(OrderService.bundleOrderCreateSurcharge, action.params.surcharge);
    yield delay(500)
    yield put({ type: Types.GET_BUNDLE_ORDER_SURCHARGE_ACTION, params: action.params.pagination });
    yield put({ type: Types.ORDER_DETAIL_ACTION, id: action.params.surcharge.orderId });
  }, errorHandleOrder(Types.ORDER_FAIL)))
}

function* bundleOrderCancelSurcharge() {
  yield takeLatest(Types.BUNDLE_ORDER_CANCEL_SURCHARGE_ACTION, Func.sagaWrapper(function* (action) {
    yield call(OrderService.bundleOrderCancelSurcharge, action.params.surcharge);
    yield delay(500)
    yield put({ type: Types.GET_BUNDLE_ORDER_SURCHARGE_ACTION, params: action.params.pagination });
    yield put({ type: Types.ORDER_DETAIL_ACTION, id: action.params.surcharge.orderId });
  }, errorHandleOrder(Types.ORDER_FAIL)))
}

function* updateSurchargeDetail() {
    yield takeLatest(Types.SURCHARGE_ITEM_DETAIL_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(OrderService.updateSurchargeDetail, action.surcharge.surcharge);
        surchargeSuccessMessage(action, (action.surcharge.surcharge.name || action.surcharge.surcharge.listType));
        yield successSurcharge(action.surcharge.surcharge, action.surcharge.props.orderItemType)
    }, errorHandleOrder(Types.ORDER_FAIL)))
}

function* createSurchargeDetail() {
    yield takeLatest(Types.SURCHARGE_ITEM_DETAIL_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(OrderService.createSurchargeDetail, action.surcharge);
        surchargeSuccessMessage(action, action.surcharge.name);
        yield delay(SAGA_DELAY_TIMEOUT)
        yield successSurcharge(action.surcharge, action.surcharge.listType)
    }, errorHandleOrder(Types.ORDER_FAIL)))
}

function* deleteSurchargeDetail() {
    yield takeLatest(Types.SURCHARGE_ITEM_DETAIL_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(OrderService.deleteSurchargeDetail, action.surcharge.id, action.surcharge.ftCode, action.surcharge.isBackStock);
        Func.sagaSuccessMessage({
            action,
            message: `${i18n.t('notification.removeSuccess')}`,
            value: `${i18n.t('item.surcharge.title')}: "${action.surcharge.name}"`
        });
        yield delay(500)
        yield successSurcharge(action.surcharge, action.surcharge.listType)
    }, errorHandleOrder(Types.ORDER_FAIL)));
}

function* updateTourItem() {
    yield takeLatest(Types.ORDER_UPDATE_TOUR_ITEM_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(TourService.updateOrderTourItem, action.tourItem);
        orderSuccessMessage(action, action.tourItem.tourName);
        yield put(OrderActions.getOrderItemAction(action.tourItem.orderId))
    }, errorHandleOrder(Types.ORDER_FAIL)))
}

function* updateOrderItemStatus() {
    yield takeLatest(Types.ORDER_ITEM_UPDATE_STATUS_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(OrderService.updateStatusOrderItem, action.item);
        orderSuccessMessage(action, `${i18n.t('notification.updateSuccess')}`);
        yield action?.callback?.onSuccess ? action?.callback?.onSuccess() : null;
        yield put(OrderActions.getOrderItemAction(action.item.orderId))
        yield delay(500)
        yield put({ type: Types.ORDER_DETAIL_ACTION, id: action.item.orderId });
    }, errorHandleOrder(Types.ORDER_FAIL)))
}

function* lockOrderItem() {
    yield takeLatest(Types.ORDER_ITEM_LOCK_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(OrderService.lockOrderItem, action.item);
        orderSuccessMessage(action, `${i18n.t('notification.updateSuccess')}`);
        yield put(OrderActions.getOrderItemAction(action.item.orderId));
    }, errorHandleOrder(Types.ORDER_FAIL)))
}

function* recommitTourOrder() {
    yield takeLatest(Types.ORDER_TOUR_RECOMMIT_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(OrderService.recommitTourOrder, action.id);
        orderSuccessMessage(action, `${i18n.t('notification.updateSuccess')}`);
        yield delay(SAGA_DELAY_TIMEOUT)
        yield put({ type: Types.ORDER_DETAIL_ACTION, id: action.id });
        yield put({ type: Types.ORDER_ITEM_GET_ACTION, id: action.id });
    }, errorHandleOrder(Types.ORDER_TOUR_RECOMMIT_FAILED)))
}

function* updateOrderStatus() {
    yield takeLatest(Types.ORDER_TOUR_UPDATE_STATUS_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(OrderService.updateOrderStatus, action.order);
        orderSuccessMessage(action, `${i18n.t('notification.updateSuccess')}`);
        yield delay(SAGA_DELAY_TIMEOUT)
        yield put({ type: Types.ORDER_DETAIL_ACTION, id: action.order.id });
    }, errorHandleOrder(Types.ORDER_TOUR_UPDATE_STATUS_FAILED)))
}

function* checkDataRedeem() {
    yield takeLatest(Types.ORDER_ITEM_CHECK_REDEEM_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        const result = yield call(OrderService.checkDataRedeem, action.data);
        yield put(OrderActions.setInfoRedeemItem(result));
        orderSuccessMessage(action, `${i18n.t('notification.checkSuccess')}`);
        // yield put({ type: Types.ORDER_ITEM_CHECK_REDEEM_SUCCESS, redeemData: result });
    }, errorHandleOrder(Types.ORDER_TOUR_UPDATE_STATUS_FAILED)))
}

function* redeemItem() {
    yield takeLatest(Types.ORDER_ITEM_REDEEM_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        const result = yield call(OrderService.redeemItem, action.item, action.index);
        yield put({ type: Types.ORDER_ITEM_REDEEM_SUCCESS, redeemData: result });
        yield action?.callBack?.onSuccess ? action?.callBack?.onSuccess() : null;
        orderSuccessMessage(action, `${i18n.t('notification.updateSuccess')}`);
        yield put(OrderActions.getOrderItemAction(action.item.orderId))
        yield delay(500)
        yield put({ type: Types.ORDER_DETAIL_ACTION, id: action.item.orderId });
    }, errorRedeemItem(Types.ORDER_ITEM_REDEEM_FAIL)))
}

function* successSurcharge(surcharge, orderItemType) {
    yield put(OrderActions.getItemSurchargeOrder({
        orderId: surcharge.orderId,
        itemVariantId: surcharge.itemVariantId
    }, orderItemType));
    yield put({ type: Types.ORDER_DETAIL_ACTION, id: surcharge.orderId });
}


function orderSuccessMessage(action, message, description) {
    return Func.sagaSuccessMessage({ action, message, description })
}

function surchargeSuccessMessage(action, value) {
    return Func.sagaSuccessMessage({
        action,
        message: `${i18n.t('notification.createSuccess')}`,
        description: `${i18n.t('item.surcharge.title')}: "${value}"`
    })
}

function* changeRateCode() {
    yield takeLatest(Types.CHANGE_RATE_CODE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(OrderService.changeRateCode, action.change);
        orderSuccessMessage(action, `${i18n.t('notification.changeRateCodeSuccess')}`);
        yield put({ type: Types.CHANGE_RATE_CODE_SUCCESS });
        yield delay(1000)
        yield put({ type: Types.ORDER_ITEM_GET_ACTION, id: action.change.orderId });
        yield put({ type: Types.ORDER_DETAIL_ACTION, id: action.change.orderId });
    }, errorHandleOrder(Types.ORDER_FAIL)))
}

function* recommitHotelBundle() {
    yield takeLatest(Types.ORDER_RECOMMIT_HOTEL_BUNDLE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(OrderService.recommitHotelBundle, action.data);
        orderSuccessMessage(action, `${i18n.t('notification.updateSuccess')}`);
        yield delay(SAGA_DELAY_TIMEOUT)
        yield put({ type: Types.ORDER_DETAIL_ACTION, id: action.data.orderId });
        yield put({ type: Types.ORDER_ITEM_GET_ACTION, id: action.data.orderId });
    }, errorHandleOrder(Types.ORDER_TOUR_RECOMMIT_FAILED)))
}

// flight tracking
function* createFlightTracking() {
    yield takeLatest(Types.CREATE_FLIGHT_TRACKING_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(OrderService.createFlightTracking, action.data);
        orderSuccessMessage(action, `${i18n.t('notification.createSuccess')}`);
        yield delay(SAGA_DELAY_TIMEOUT)
        yield put({ type: Types.ORDER_DETAIL_ACTION, id: action.data.orderId });
        yield put({ type: Types.ORDER_ITEM_GET_ACTION, id: action.data.orderId });
        yield put({ type: Types.GET_ALL_FLIGHT_TRACKING_ORDER_ACTION, orderId: action.data.orderId});
    }, errorHandleOrder(Types.CREATE_FLIGHT_TRACKING_FAIL)))
}

function* updateFlightTracking() {
    yield takeLatest(Types.UPDATE_FLIGHT_TRACKING_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(OrderService.updateFlightTracking, action.data);
        orderSuccessMessage(action, `${i18n.t('notification.updateSuccess')}`);
        yield delay(SAGA_DELAY_TIMEOUT)
        yield put({ type: Types.ORDER_DETAIL_ACTION, id: action.data.orderId });
        yield put({ type: Types.ORDER_ITEM_GET_ACTION, id: action.data.orderId });
        yield put({ type: Types.GET_ALL_FLIGHT_TRACKING_ORDER_ACTION, orderId: action.data.orderId});
    }, errorHandleOrder(Types.UPDATE_FLIGHT_TRACKING_FAIL)))
}

function* deleteFlightTracking(){
    yield takeLatest(Types.DELETE_FLIGHT_TRACKING_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(OrderService.deleteFlightTracking, action.data);
        Func.sagaSuccessMessage({
            action,
            message: `${i18n.t('notification.removeSuccess')}`,
            value: `${i18n.t('item.order.flightInfo')}: "${action.data.airlineNumber}"`
        });
        yield delay(SAGA_DELAY_TIMEOUT);
        yield put({ type: Types.ORDER_DETAIL_ACTION, id: action.data.orderId });
        yield put({ type: Types.ORDER_ITEM_GET_ACTION, id: action.data.orderId });
        yield put({ type: Types.GET_ALL_FLIGHT_TRACKING_ORDER_ACTION, orderId: action.data.orderId});
    }, errorHandleOrder(Types.DELETE_FLIGHT_TRACKING_FAIL)))
}

function* getAllFlightTrackingOrder(){
    yield takeLatest(Types.GET_ALL_FLIGHT_TRACKING_ORDER_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(OrderService.getFlightTrackingOrder, action.orderId);
        yield put(OrderActions.setListFlightTrackingOrder(result.data.data));
    }, errorHandleOrder(Types.GET_ALL_FLIGHT_TRACKING_ORDER_FAIL)))
}

function errorHandleOrder(errorActionType, isMessagePriority = false) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'order', true, isMessagePriority);
}

function errorRedeemItem(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType, error: get(e, 'errors[0].code')})
    }, 'order');
}

function* vinwonderCustomers() {
    yield takeLatest(Types.VINWONDER_CUSTOMERS_GET_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(OrderService.getVinwonderCustomers, action.id);
        yield put(OrderActions.getVinwonderCustomersSuccess(result));
    }, errorHandleOrder(Types.ORDER_FAIL)))
}

function* smsHistories() {
    yield takeLatest(Types.SMS_HISTORIES_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(OrderService.getSmsHistories, action.id);
        yield put(OrderActions.getSmsHistoriesSuccess(result));
    }, errorHandleOrder(Types.ORDER_FAIL)))
}

function* resendSms() {
    yield takeLatest(Types.SMS_RESEND_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(OrderService.resendSms, action.id, action.orderId);
        yield put(OrderActions.resendSmsSuccess(result));
        yield put({ type: Types.SMS_HISTORIES_ACTION, id: action.orderId });
    }, errorHandleOrder(Types.ORDER_FAIL)))
}

function* updateProfileOrder() {
    yield takeLatest(Types.UPDATE_PROFILE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(OrderService.updateOrderProfile, action.profile);
        // yield put(OrderActions.getSmsHistoriesSuccess(result));
        yield put({ type: Types.UPDATE_PROFILE_SUCCESS });
        yield put({ type: Types.ORDER_DETAIL_ACTION, id: action.orderId });
        return Func.sagaSuccessMessage({
            action,
            message: `${i18n.t('notification.updateSuccess')}`,
            description: `${result?.message || ""}`
        })
    }, errorHandleOrder(Types.ORDER_FAIL)))
}

function* resendFixCharge() {
    yield takeLatest(Types.FIXCHARGE_RESEND_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(OrderService.resendFixCharge, action.id);
        
        return Func.sagaSuccessMessage({
            action,
            message: `${i18n.t('notification.pushFixedChargeSuccess')}`,
            description: `${result?.message || ""}`
        })
        
    }, errorHandleOrder(Types.ORDER_FAIL)))
}

function* repushAffiliate() {
    yield takeLatest(Types.AFFILIATE_REPUSH_ACTION, Func.sagaWrapper(function* (action) {
        yield call(OrderService.repushAffiliate, action.orderId, action.status);
        orderSuccessMessage(action, i18n.t('notification.repushAffiliateSuccess'));
        yield put({ type: Types.AFFILIATE_REPUSH_SUCCESS });
    }, errorHandleOrder(Types.AFFILIATE_REPUSH_FAIL)))
}
function* pointHistoriesSaga() {
    yield takeLatest(Types.POINT_HISTORIES_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(OrderService.getPointHistories, action.id);
        yield put(OrderActions.getPointHistoriesSuccess(result));
    }, errorHandleOrder(Types.ORDER_FAIL)))
}

function* refundOrderPointSaga() {
    yield takeLatest(Types.REFUND_ORDER_POINT_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(OrderService.refundOrderPoint, action.id);
        yield put(OrderActions.refundOrderPointSuccess(result));
    }, function* (error) {
        const errorMessage = error?.errors?.[0]?.message || error?.message || 'Unknown error';
        yield put({ 
            type: Types.REFUND_ORDER_POINT_FAIL, 
            error: errorMessage 
        });
    }));
}

function* getOrderDetailGolf() {
    yield takeLatest(Types.ORDER_DETAIL_GOLF_ACTION, Func.sagaWrapper(function* (action) {        
        const result = yield call(OrderService.getOrderDetailGolf, action.vptOrderId);
        yield put(OrderActions.setOrderDetailGolf(result));
    }, errorHandleOrder(Types.ORDER_FAIL_GOLF)))
}

export function* orderSaga() {
    yield all([
        fork(getOrderDetailGolf),
        fork(getListOrder),
        fork(getOrderItem),
        fork(getItemVoucherOrder),
        // fork(showGetDetailVoucherOrder),
        // fork(showDataOrderInfoGroup),
        fork(reSendOrderEmail),
        fork(sendOrderEmailTemplate),
        fork(recommitTourOrder),
        fork(updateOrderStatus),

        fork(getOrderDetail),
        fork(getOrderVoucherDetailItems),
        fork(getOrderFlightDetail),
        fork(getOrderHomestayBooking),
        fork(getOrderHotelBooking),
        fork(getOrderCrossSellBooking),

        fork(exportExcel),
        fork(exportSkuExcel),
        fork(exportSkuSaleDetailExcel),
        fork(exportHotelSaleDetailExcel),
        fork(exportAccessTrade),
        fork(exportSaleOrder),
        fork(exportTourSaleOrder),
        fork(updateOrder),
        fork(updateOrderAccountant),
        fork(updateOrderInvoice),
        fork(exportVoucher),
        fork(updateFlight),

        // Surcharge
        fork(getOrderSurchargeItem),
        fork(getSurchargeDetail),
        fork(updateSurchargeDetail),
        fork(createSurchargeDetail),
        fork(deleteSurchargeDetail),
        
        fork(getBundleOrderSurcharge),
        fork(bundleOrderCreateSurcharge),
        fork(bundleOrderCancelSurcharge),

        //tourItem
        updateTourItem(),

        fork(updateOrderItemStatus),
        fork(lockOrderItem),
        fork(checkDataRedeem),
        fork(redeemItem),
        fork(changeRateCode),

        fork(recommitHotelBundle),
        fork(pushOrderFixCharge),
      
        //customers
        fork(vinwonderCustomers),

        //SMS
        fork(smsHistories),
        fork(resendSms),

        //Profile
        fork(updateProfileOrder),
        //FixCharge
        fork(resendFixCharge),

        //flightTracking
        fork(createFlightTracking),
        fork(updateFlightTracking),
        fork(deleteFlightTracking),
        fork(getAllFlightTrackingOrder),

        //Affiliate
        fork(repushAffiliate),

        // point histories
        fork(pointHistoriesSaga),

        //refund
        fork(refundOrderPointSaga),
    ])
}
